<template>
    <div>
        <div class="row">
            <div class="col-12">
                <p>Vyberte způsob vaší prezentace</p>
                <div id="presentation_cards" class="card-deck">
                    <presentation-card
                        v-for="presentation in presentations"
                        :key="presentation.id"
                        :presentation="presentation"
                        @pick-presentation="pickPresentation"
                    />
                </div>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-6 col-sm-2">
                <button
                    class="button-01"
                    @click="$store.commit('step/setStep', 'register')"
                >
                    Zpět
                </button>
            </div>
        </div>

        <div v-if="isFirmSaved">
            <modal-dialog-thanks ref="thanks"></modal-dialog-thanks>
        </div>
        <div v-else>
            Firma není uložena.
        </div>
    </div>
</template>

<script>
// import axios from 'axios';
import PresentationCard from './presentation/PresentationCard'
import ModalDialogThanks from './presentation/ModalDialogThanks'

export default {
    name: 'FormWizardFirmPresentation',
    components: {
        PresentationCard,
        ModalDialogThanks,
    },
    computed: {
        presentations() {
            return this.$store.state.presentations.presentations
        },
        userId() {
            return this.$store.state.user.id
        },
        idFirmy() {
            return this.$store.state.firm.result.id_firmy
        },
    },
    beforeMount() {
        this.$store.dispatch('presentations/fetchPresentations')
    },
    methods: {
        isFirmSaved() {
            return this.store.getters('step/isFirmSaved')
        },
        pickPresentation(presentation) {
            //u placeneho zapisu bude jeste vyber platby
            this.$refs.thanks.showThanksModal()

            this.$store.commit('firm/setPresentation', presentation)

            // v produkcnim prostredi vytvori firmu na backendu

            this.$store.dispatch('loader/setLoader', 'Ukládám firmu ...')
            const vm = this
            this.$store
                .dispatch('firm/setFirm')
                .then(() => {
                    // Klik na tlačítko zdarma na stránce výběru prezentace + parametr ID firmy
                    if (presentation === 1) {
                        ga(
                            'p.send',
                            'event',
                            'firmy-krok2-zdarma',
                            this.userId,
                            this.idFirmy
                        )
                    }

                    // Klik na tlačítko Standard na stránce výběru prezentace + parametr ID firmy
                    if (presentation === 2) {
                        ga(
                            'p.send',
                            'event',
                            'firmy-krok2-standard',
                            this.userId,
                            this.idFirmy
                        )
                    }

                    // Klik na tlačítko Nabídka na stránce výběru prezentace + parametr ID firmy
                    if (presentation === 3) {
                        ga(
                            'p.send',
                            'event',
                            'firmy-krok2-Nabidka',
                            this.userId,
                            this.idFirmy
                        )
                    }

                    this.$store
                        .dispatch('firm/executeAfterSaveActions')
                        .then(() => {
                            vm.$store.commit('step/setFirmSaved', true)
                        })
                        .catch(error => {
                            console.log(error)
                            vm.$store.dispatch('loader/setError', error)
                        })
                })
                .catch(error => {
                    console.log(error)
                    vm.$store.dispatch('loader/setError', error)
                })
        },
    },
}
</script>
